import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {CommonComponent} from '../../shared/common/common.component';
import {Retailer} from '../../../domain/accounts/retailer';
import {BarcodeService} from '../../../services/barcode.service';
import {CatalogsService} from '../../../services/catalogs.service';
import {ECatalog} from '../../../enums/ECatalog';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../../../../environments/environment';
import {BarcodeEntity} from '../../../entity/BarcodeEntity';
import {BarcodeType, IBarcode} from '../../../domain/accounts/IBarcode';
import {AccountService} from '../../../services/account.service';
import {ConfigurationService} from '../../../services/configuration.service';
import {AccountConfiguration} from '../../../domain/configurations';

@Component({
  selector: 'app-create-barcode',
  templateUrl: './create-barcode.component.html',
  styleUrls: ['./create-barcode.component.scss']
})

export class CreateBarcodeComponent extends CommonComponent implements OnInit {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  configuration: AccountConfiguration;
  retailers: Retailer[];
  barcode: IBarcode;
  isOwner: boolean;
  productName = environment.productName;
  phoneCountryCode: string = null;
  NgForm = NgForm;
  verifyData = false;
  displayInvalidThirdAccount = false;
  createdCode: IBarcode;
  thirdPartyInformation: any;
  thirdPartyName: string;
  showThirdPartyInfo = false;
  enableCreateThirdPartyBtn = false;
  options: NgbModalOptions;
  constructor(
    private barcodeService: BarcodeService,
    private catalogService: CatalogsService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private accountsService: AccountService,
    private configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configuration = this.configurationService.account;
    this.options =  {
      beforeDismiss: () => {
        this.router.navigate(['/account/newCode']);
        return true;
      },
      centered: true
    };
  }
  ngOnInit():
    void {
    this.getRetailersCatalog();
    this.isOwner = true;
    this.barcode = new BarcodeEntity();
    this.phoneCountryCode = !this.phoneCountryCode ? '1' : this.phoneCountryCode;
    this.barcode.targetReference = '550296';
  }
  onSubmit(form: NgForm) {
    this.loadingModalOn();
    if (!this.isOwner){
      this.barcode.loadType = BarcodeType.THIRD_PARTY_ACCOUNT;
    } else {
      this.barcode.targetReference = '';
      this.barcode.loadType = BarcodeType.OWNER_ACCOUNT;
    }
    this.barcode.retailerKey = this.barcode.retailer.key;
    this.barcodeService.createBarcode(this.barcode).subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('accounts.create_barcode.validate'));
        this.createdCode = response;
        this.loadingModalOff();
        this.openBarcode();
        form.resetForm();
        this.barcode.targetReference = '550296';
        this.isOwner = true;
        this.showThirdPartyInfo = false;
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  openBarcode() {
    this.modalService.open(this.modalContent, this.options);
    this.loadingModalOff();
    this.barcode.targetReference = '550296';
  }
  getRetailersCatalog() {
    this.loadingModalOn();
    this.catalogService.getCatalog(ECatalog.RETAILERS).subscribe(
      (response: any) => {
        this.retailers = response;
        this.loadingModalOff();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  verifyThirdParty(cardNumber: string) {
    this.loadingModalOn();
    this.accountsService.searchCard(cardNumber).subscribe(
      (response: any) => {
        this.thirdPartyInformation = response;
        this.thirdPartyName = this.thirdPartyInformation.maskedFirstName.replaceAll('X', '●') + ' ' + this.thirdPartyInformation.maskedLastName.replaceAll('X', '●');
        this.barcode.targetFirstName = this.thirdPartyInformation.maskedFirstName;
        this.barcode.targetLastName = this.thirdPartyInformation.maskedLastName;
        this.verifyData = true;
        this.loadingModalOff();
      }, error => {
        this.loadingModalOff();
        this.displayInvalidThirdAccount = true;
        this.barcode.targetReference = '550296';
      }
    );
  }
  // Function to keep first six digits
  onInputChange(event: any) {
    const inputValue = event.target.value;
    const textWithoutSpace = inputValue.replace(/\s/g, '');
    if (textWithoutSpace === 16) {
      textWithoutSpace.substring(7);
      this.barcode.targetReference = '550296' + textWithoutSpace;
    } else if (inputValue.length < 6 || event.key === 'Delete') {
      this.barcode.targetReference = '550296';
    }
  }
  confirmTargetBarcode(){
    this.verifyData = false;
    this.enableCreateThirdPartyBtn = true;
    this.showThirdPartyInfo = true;
  }
}
